// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';  // This should have your Tailwind imports
import AppWithShifts from './App_with_shifts';
import StandaloneItinerary from './components/StandaloneItinerary';
import ExternalDoctorDesk from './components/ExternalDoctorDesk';
import ExternalItinerary from './components/ExternalItinerary';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { SnackbarProvider } from 'notistack';
import AppVersionChecker from './components/AppVersionChecker';

// Simple routing based on URL path
const isItineraryPage = window.location.pathname === '/itinerary';
const isExternalDoctorDesk = window.location.pathname === '/external-doctor-desk';
const isExternalItinerary = window.location.pathname === '/external-itinerary';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <SnackbarProvider maxSnack={3}>
        <AppVersionChecker />
        {isExternalDoctorDesk ? (
          <ExternalDoctorDesk />
        ) : isExternalItinerary ? (
          <ExternalItinerary />
        ) : isItineraryPage ? (
          <StandaloneItinerary />
        ) : (
          <AppWithShifts />
        )}
      </SnackbarProvider>
    </LocalizationProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
